import React from "react";
import "./assets/Layout.css";

/**
 * Minimal ve çatışmasız auth layout.
 * Neden: Global `.container` (Bootstrap/Tailwind) ile çakışmayı kalıcı çözer.
 */
const Layout = ({ children, className = "" }) => {
  return (
    <div className="app-layout">
      <div className={`app-layout__card ${className}`}>{children}</div>
    </div>
  );
};

export default Layout;
